import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'

export const useGetProductsDropdown = () => {
  const Api = useApi()
  const initialFilters = {
    page: 1,
    limit: 20,
    search: '',
    classification_filter: '',
  }

  const {filters, setSingleFilter, setMultipleFilters, onSearch} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery(
    `/analytics/profitability/filters/products`,
    {
      queryId: 'product-filtered-products-dropdown',
      filters: filters,
    }
  )

  const onPageChange = (page_number: number) => {
    setSingleFilter('page', page_number)
  }

  const onClassificationChange = (classificationValues: any) => {
    setMultipleFilters({
      classification_filter: classificationValues.map((item: any) => item.label).join(','),
      page: 1,
    })
  }

  return {
    products: response?.data || [],
    pagination: response?.meta || {},
    isLoading: isFetching,
    onPageChange,
    onSearch,
    onClassificationChange,
  }
}
